import React from 'react'
import PropTypes from 'prop-types'
import ProductsList from './partials/productsList'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

export const CondensedCategorySlider = ({changeToGrid, ...rest}) => {
    return (
        <Box
            className="condensed-products"
            display={{base: 'block', lg: 'none'}}
            marginTop="auto"
            marginBottom="auto"
            paddingLeft={{
                '2xl': '90px',
                xl: '80px',
                lg: '70px',
                md: '16px',
                base: 0
            }}
            paddingTop="0"
            paddingBottom={{md: '0', lg: '0', xl: '50px'}}
            height="125px"
        >
            <ProductsList {...rest} changeToGrid={changeToGrid} />
        </Box>
    )
}

CondensedCategorySlider.propTypes = {
    changeToGrid: PropTypes.bool
}

export default CondensedCategorySlider
